import React from 'react';
import './BackgroundPattern.css';

const BackgroundPattern = () => {
  // SVG للنجمة الثلاثية لمرسيدس (ثلاث نقاط متصلة من المركز)
  // النجمة الثلاثية: ثلاث نقاط في دائرة متصلة بخطوط من المركز
  const mercedesStarSVG = encodeURIComponent(`
    <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.12">
        <!-- دائرة خارجية -->
        <circle cx="50" cy="50" r="40" fill="none" stroke="#E5E5E5" stroke-width="0.5"/>
        <!-- النقطة العلوية -->
        <circle cx="50" cy="15" r="4" fill="#E5E5E5"/>
        <!-- النقطة اليسرى السفلية -->
        <circle cx="15" cy="85" r="4" fill="#E5E5E5"/>
        <!-- النقطة اليمنى السفلية -->
        <circle cx="85" cy="85" r="4" fill="#E5E5E5"/>
        <!-- خط من المركز للنقطة العلوية -->
        <line x1="50" y1="50" x2="50" y2="15" stroke="#E5E5E5" stroke-width="0.8"/>
        <!-- خط من المركز للنقطة اليسرى -->
        <line x1="50" y1="50" x2="15" y2="85" stroke="#E5E5E5" stroke-width="0.8"/>
        <!-- خط من المركز للنقطة اليمنى -->
        <line x1="50" y1="50" x2="85" y2="85" stroke="#E5E5E5" stroke-width="0.8"/>
      </g>
    </svg>
  `);

  return (
    <div className="background-pattern">
      <div 
        className="mercedes-stars-container"
        style={{
          backgroundImage: `url("data:image/svg+xml,${mercedesStarSVG}")`
        }}
      />
    </div>
  );
};

export default BackgroundPattern;
